import React from 'react'
import Conversation from '../../../pages/Conversation'


const AgentConversation = () => {
    return (
        <Conversation view="agent" />
    )
}

export default AgentConversation
